import { Component, Inject, OnInit } from '@angular/core';
import { NbWindowRef, NB_WINDOW_CONTEXT } from '@nebular/theme';

@Component({
  selector: 'ubs-ofbiz-summary-window',
  templateUrl: './ofbiz-summary-window.component.html',
  styleUrls: ['./ofbiz-summary-window.component.scss']
})
export class OfbizSummaryWindowComponent implements OnInit {
  summaryViews:any[];
  fieldList:any[];
  existingValues:any;
  cards:number = 0;

  constructor(protected windowRef: NbWindowRef,@Inject(NB_WINDOW_CONTEXT) data) { 
    console.log(data);
    console.log(data.componentConfig.cmsComponentConfig);
    if(data.componentConfig.cmsComponentConfig.summaryView){
      this.summaryViews = data.componentConfig.cmsComponentConfig.summaryView;
      this.cards = this.summaryViews.length;
      console.log(this.summaryViews);
    }
    if(data.fieldList){
      this.fieldList = data.fieldList;
    }
    if(data.existingValues){
      this.existingValues = data.existingValues;
    }
  }

  ngOnInit(): void {
  }

}
